import React from "react";
import { useNavigate } from "react-router-dom";
import { IconButton } from "@mui/material";
import BackIcon from "@mui/icons-material/ArrowBack";
import { BackButtonStyle, BackButtonRow } from "./Styled"

interface BackButtonProps {
    route?: string;
    label?: string;
    onClick?: () => void;
}
  
const BackButton = ({ route, label, onClick } : BackButtonProps) => {
    const navigate = useNavigate();
  
    const handleClick = () => {
        if (onClick) {
            onClick();
        } else if (route) {
            navigate(route);
        } else {
            navigate(-1);
        }
    };
  
    return (
        <BackButtonRow>
            <IconButton style={BackButtonStyle} onClick={handleClick}>
                <BackIcon />
            </IconButton>
            {label}
        </BackButtonRow>
    );
};
  
export default BackButton;